export function isInternalUserEmail(email: string) {
  return (
    email?.endsWith("@jobmate.ch") ||
    email?.endsWith("@powercoders.org") ||
    email?.endsWith("@iterativ.ch") ||
    email?.endsWith("@loia.ch") ||
    email === "jobmate@ik.me" ||
    email === "jobmate+cypress@ik.me"
  );
}
